import React from "react";
import ReactDOM from "react-dom/client";
import * as Sentry from "@sentry/react";
import { ClerkProvider } from "@clerk/react";
import App from "./App";
import "./index.css";
import "./styles.css";
import { logger } from "./lib/logger";
import { areDiagnosticsEnabled } from "./lib/privacyPreferences";

const clerkPublishableKey = import.meta.env.VITE_CLERK_PUBLISHABLE_KEY;

if (import.meta.env.VITE_SENTRY_DSN && areDiagnosticsEnabled()) {
  Sentry.init({
    dsn: import.meta.env.VITE_SENTRY_DSN,
    environment: import.meta.env.MODE,
    integrations: [
      Sentry.browserTracingIntegration(),
      // Replay only on errors; masks all text to protect PII
      Sentry.replayIntegration({ maskAllText: true, blockAllMedia: true }),
    ],
    tracesSampleRate: 0.1,
    replaysSessionSampleRate: 0.0,
    replaysOnErrorSampleRate: 1.0,
  });
}

logger.info("Monyawn init", {
  version: import.meta.env.VITE_APP_VERSION ?? "dev",
  mode: import.meta.env.MODE,
});

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    {clerkPublishableKey ? (
      <ClerkProvider publishableKey={clerkPublishableKey}>
        <App clerkEnabled />
      </ClerkProvider>
    ) : (
      <App />
    )}
  </React.StrictMode>,
);
